import React, { useState } from "react";
import { withAppContextDecorators } from '@/common/AppContext';
import { Breadcrumb ,Tabs } from 'antd';
import './index.less';
import LayoutContainer from "@/components/pc/LayoutContainer";
import EnterpriseQualification from "./enterpriseQualification";
import ComplianceConcept from "./complianceConcept";
import UserNotice from "./userNotice";
import InvestmentProtection from "./investmentProtection";
import Regulations from "./regulations";
import Assistant from "./assistant";
import { useParams } from 'react-router-dom'

const Compliance = (props) => {
    const { activeMenu } = useParams();
    const renderContent = () => {
        switch (activeMenu) {
            case 'qualification':
                return <EnterpriseQualification />;
            case 'concept':
                return <ComplianceConcept />;
            case 'notice':
                return <UserNotice />;
            case 'protection':
                return <InvestmentProtection />;
            case 'regulations':
                return <Regulations />;
            default:
                return <EnterpriseQualification />;
        }
    };

    return <LayoutContainer><div id="compliance">
        <div className={'banner'}>
           <img src={require('@/assets/images/compliance/banner.jpg')} />
        </div>

        <div className='content'>
            {renderContent()}
        </div>
    </div>
    </LayoutContainer>
}
export default withAppContextDecorators(Compliance)
